// import React, { useEffect, useState } from "react";
// import '../styles/companysetup.css';
// const CompanySetup = () => {

//     const [locations, setLocations] = useState([]);

//     const [formData, setFormData] = useState({
//         office_type: "",
//         region: "",
//         address: "",
//         embed_url: "",
//         map_url: ""
//     });

//     const fetchLocations = async () => {
//         try {
//             const res = await fetch(
//                 "/gt-api/get_company_locations.php",
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setLocations(data.locations || []);
//             }

//         } catch (err) {
//             console.error(err);
//         }
//     };

//     useEffect(() => {
//         fetchLocations();
//     }, []);

//     const handleChange = (e) => {
//         setFormData(prev => ({
//             ...prev,
//             [e.target.name]: e.target.value
//         }));
//     };

//     const handleSave = async () => {

//         if (
//             !formData.office_type ||
//             !formData.region ||
//             !formData.address
//         ) {
//             alert("Please fill all required fields.");
//             return;
//         }

//         try {

//             const res = await fetch(
//                 "/gt-api/save_company_location.php",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     credentials: "include",
//                     body: JSON.stringify(formData)
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {

//                 alert("Location saved successfully");

//                 setFormData({
//                     office_type: "",
//                     region: "",
//                     address: "",
//                     embed_url: "",
//                     map_url: ""
//                 });

//                 fetchLocations();
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Save failed");
//         }
//     };

//     const handleDelete = async (id) => {

//         if (!window.confirm("Delete this location?")) {
//             return;
//         }

//         try {

//             const res = await fetch(
//                 "/gt-api/delete_company_location.php",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     credentials: "include",
//                     body: JSON.stringify({ id })
//                 }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 fetchLocations();
//             }

//         } catch (err) {
//             console.error(err);
//         }
//     };

//     return (
//         <div className="management-salary-container animate-fade">

//             {/* ================= ADD LOCATION ================= */}
//             <div className="module-glass-card">

//                 <h2 className="cyan-text">
//                     COMPANY SETUP
//                 </h2>

//                 <div className="cyber-line"></div>

//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "flex-start",
//                         marginBottom: "25px",
//                         gap: "20px"
//                     }}
//                 >
//                     <div>
//                         <h3 style={{ margin: 0 }}>
//                             🏢 Campus Information
//                         </h3>

//                         <p
//                             style={{
//                                 marginTop: "8px",
//                                 opacity: 0.8,
//                                 fontSize: "13px",
//                                 lineHeight: "1.6"
//                             }}
//                         >
//                             Add all office locations that should be visible to employees.
//                             You can add multiple campuses, headquarters, branch offices,
//                             warehouses, client offices, or regional locations.
//                         </p>
//                     </div>

//                     <button
//                         className="btn-action approve"
//                         onClick={() =>
//                             setFormData({
//                                 office_type: "",
//                                 region: "",
//                                 address: "",
//                                 embed_url: "",
//                                 map_url: ""
//                             })
//                         }
//                     >
//                         ➕ ADD MORE
//                     </button>
//                 </div>

//                 <div className="form-row">

//                     <div className="form-group">
//                         <label>Office Type</label>

//                         <input
//                             className="cyber-input"
//                             name="office_type"
//                             value={formData.office_type}
//                             onChange={handleChange}
//                             placeholder="Head Office / Branch Office / Warehouse"
//                         />
//                     </div>

//                     <div className="form-group">
//                         <label>Region</label>

//                         <input
//                             className="cyber-input"
//                             name="region"
//                             value={formData.region}
//                             onChange={handleChange}
//                             placeholder="Pune, India"
//                         />
//                     </div>

//                 </div>

//                 <div className="form-group">
//                     <label>Office Address</label>

//                     <textarea
//                         className="cyber-input"
//                         rows="3"
//                         name="address"
//                         value={formData.address}
//                         onChange={handleChange}
//                         placeholder="Enter complete office address"
//                     />
//                 </div>

//                 <div className="form-group">
//                     <label>Google Maps Embed URL</label>

//                     <input
//                         className="cyber-input"
//                         name="embed_url"
//                         value={formData.embed_url}
//                         onChange={handleChange}
//                         placeholder="https://www.google.com/maps/embed?..."
//                     />
//                 </div>

//                 <div className="form-group">
//                     <label>Google Navigation URL</label>

//                     <input
//                         className="cyber-input"
//                         name="map_url"
//                         value={formData.map_url}
//                         onChange={handleChange}
//                         placeholder="https://maps.google.com/..."
//                     />
//                 </div>

//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "flex-end",
//                         marginTop: "20px"
//                     }}
//                 >
//                     <button
//                         className="btn-action approve"
//                         onClick={handleSave}
//                     >
//                         💾 SAVE & ADD LOCATION
//                     </button>
//                 </div>

//             </div>

//             {/* ================= EXISTING LOCATIONS ================= */}
//             <div
//                 className="module-glass-card"
//                 style={{ marginTop: "20px" }}
//             >

//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         marginBottom: "20px"
//                     }}
//                 >
//                     <h3 style={{ margin: 0 }}>
//                         Existing Locations
//                     </h3>

//                     <span
//                         style={{
//                             background: "rgba(14,165,233,0.15)",
//                             color: "#38bdf8",
//                             padding: "6px 12px",
//                             borderRadius: "20px",
//                             fontSize: "12px",
//                             fontWeight: "600"
//                         }}
//                     >
//                         {locations.length} Locations
//                     </span>
//                 </div>

//                <div className="admin-table-container">

//     <table
//         className="cyber-table"
//         style={{
//             width: "100%",
//             tableLayout: "fixed"
//         }}
//     >

//         <thead>
//             <tr>
//                 <th style={{ width: "18%" }}>OFFICE TYPE</th>
//                 <th style={{ width: "18%" }}>REGION</th>
//                 <th style={{ width: "44%" }}>ADDRESS</th>
//                 <th style={{ width: "20%", textAlign: "center" }}>ACTION</th>
//             </tr>
//         </thead>

//         <tbody>

//             {locations.length > 0 ? (

//                 locations.map(loc => (

//                     <tr key={loc.id}>

//                         <td>
//                             {loc.office_type}
//                         </td>

//                         <td>
//                             {loc.region}
//                         </td>

//                         <td
//                             style={{
//                                 whiteSpace: "normal",
//                                 wordBreak: "break-word",
//                                 lineHeight: "1.6"
//                             }}
//                         >
//                             {loc.address}
//                         </td>

//                         <td
//                             style={{
//                                 textAlign: "center",
//                                 verticalAlign: "middle"
//                             }}
//                         >

//                             <button
//                                 onClick={() => handleDelete(loc.id)}
//                                 style={{
//                                     background: "rgba(239,68,68,0.15)",
//                                     color: "#ef4444",
//                                     border: "1px solid rgba(239,68,68,0.35)",
//                                     borderRadius: "10px",
//                                     padding: "10px 18px",
//                                     cursor: "pointer",
//                                     fontSize: "13px",
//                                     fontWeight: "600",
//                                     minWidth: "120px"
//                                 }}
//                             >
//                                 🗑 Delete
//                             </button>

//                         </td>

//                     </tr>

//                 ))

//             ) : (

//                 <tr>
//                     <td
//                         colSpan="4"
//                         style={{
//                             textAlign: "center",
//                             padding: "40px"
//                         }}
//                     >
//                         <div>
//                             <div
//                                 style={{
//                                     fontSize: "40px",
//                                     marginBottom: "10px"
//                                 }}
//                             >
//                                 🏢
//                             </div>

//                             <div
//                                 style={{
//                                     fontWeight: "600",
//                                     marginBottom: "8px"
//                                 }}
//                             >
//                                 No Campus Locations Added Yet
//                             </div>

//                             <div
//                                 style={{
//                                     opacity: 0.7,
//                                     fontSize: "13px"
//                                 }}
//                             >
//                                 Add your first office location above.
//                                 Employees will automatically see it under
//                                 Campus Information.
//                             </div>
//                         </div>
//                     </td>
//                 </tr>

//             )}

//         </tbody>

//     </table>

// </div>

//             </div>

//         </div>
//     );
// };

// export default CompanySetup;

























import React, { useEffect, useState } from "react";
import '../styles/companysetup.css';
const CompanySetup = () => {

    const [activeTab, setActiveTab] = useState("campus");
    const [managerName, setManagerName] = useState("");
    const [managerRole, setManagerRole] = useState("");

    const [teamName, setTeamName] = useState("");
    const [selectedManager, setSelectedManager] = useState("");

    const [employeeName, setEmployeeName] = useState("");
    const [employeeRole, setEmployeeRole] = useState("");
    const [selectedTeam, setSelectedTeam] = useState("");

    const [locations, setLocations] = useState([]);
    const [boardName, setBoardName] = useState("");
    const [boardRole, setBoardRole] = useState("");

    const [ceoName, setCeoName] = useState("");
    const [ceoRole, setCeoRole] = useState("CEO");

    const [orgChartData, setOrgChartData] = useState([]);
    const [policyTitle, setPolicyTitle] = useState("");
    const [policyIcon, setPolicyIcon] = useState("📄");
    const [policyContent, setPolicyContent] = useState("");

    const [policies, setPolicies] = useState([]);

    const [pathwayTitle, setPathwayTitle] = useState("");
    const [pathwayIcon, setPathwayIcon] = useState("📈");
    const [pathwayContent, setPathwayContent] = useState("");

    const [careerPathways, setCareerPathways] = useState([]);
    const [festivalName, setFestivalName] = useState("");
    const [festivalDate, setFestivalDate] = useState("");
    const [festivalImage, setFestivalImage] = useState("");
    const [festivals, setFestivals] = useState([]);


    const [formData, setFormData] = useState({
        office_type: "",
        region: "",
        address: "",
        embed_url: "",
        map_url: ""
    });

    const fetchLocations = async () => {
        try {
            const res = await fetch(
                "/gt-api/get_company_locations.php",
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            if (data.success) {
                setLocations(data.locations || []);
            }

        } catch (err) {
            console.error(err);
        }
    };

    const fetchCareerPathways = async () => {

        try {

            const res = await fetch(
                "/gt-api/get_career_pathways.php",
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            if (data.success) {
                setCareerPathways(
                    data.pathways || []
                );
            }

        } catch (err) {
            console.error(err);
        }

    };

    const fetchFestivals = async () => {

        try {

            const res = await fetch(
                "/gt-api/get_festivals.php",
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            if (data.success) {
                setFestivals(data.festivals || []);
            }

        } catch (err) {
            console.error(err);
        }

    };

    const fetchOrgChart = async () => {

        try {

            const res = await fetch(
                "/gt-api/get_org_chart.php",
                {
                    credentials: "include"
                }
            );

            const data = await res.json();

            console.log(data);

            if (data.success) {
                setOrgChartData(data.records || []);
            }

        } catch (err) {
            console.error(err);
        }

    };

    useEffect(() => {
        fetchLocations();
        fetchOrgChart();
        fetchPolicies();
        fetchCareerPathways();
        fetchFestivals();
    }, []);

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {

        if (
            !formData.office_type ||
            !formData.region ||
            !formData.address
        ) {
            alert("Please fill all required fields.");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_company_location.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify(formData)
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("Location saved successfully");

                setFormData({
                    office_type: "",
                    region: "",
                    address: "",
                    embed_url: "",
                    map_url: ""
                });

                fetchLocations();
            }

        } catch (err) {
            console.error(err);
            alert("Save failed");
        }
    };

    const handleDelete = async (id) => {

        if (!window.confirm("Delete this location?")) {
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/delete_company_location.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({ id })
                }
            );

            const data = await res.json();

            if (data.success) {
                fetchLocations();
            }

        } catch (err) {
            console.error(err);
        }
    };




    const saveBoardMember = async () => {

        if (!boardName || !boardRole) {
            alert("Please enter board member details");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_org_chart.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        section_type: "BOARD",
                        title: boardName,
                        subtitle: boardRole
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("Board Member Added");

                setBoardName("");
                setBoardRole("");

                fetchOrgChart();
            }

        } catch (err) {
            console.error(err);
        }
    };

    const saveCEO = async () => {

        if (!ceoName) {
            alert("Enter CEO Name");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_org_chart.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        section_type: "CEO",
                        title: ceoName,
                        subtitle: ceoRole
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("CEO Saved");

                fetchOrgChart();
            }

        } catch (err) {
            console.error(err);
        }
    };


    const saveManager = async () => {

        if (!managerName || !managerRole) {
            alert("Please fill all fields");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_manager.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        managerName,
                        managerRole
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("Manager Added");

                setManagerName("");
                setManagerRole("");
                fetchOrgChart();   // ADD THIS

            }

        } catch (err) {
            console.error(err);
        }
    };

    const saveTeam = async () => {

        if (!selectedManager || !teamName) {
            alert("Select manager and enter team name");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_team.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        managerId: selectedManager,
                        teamName
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("Team Added");

                setTeamName("");
                setSelectedManager("");

                fetchOrgChart();
            }

        } catch (err) {
            console.error(err);
        }
    };


    const saveEmployee = async () => {

        if (
            !selectedTeam ||
            !employeeName ||
            !employeeRole
        ) {
            alert("Fill all employee fields");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_employee.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        teamId: selectedTeam,
                        employeeName,
                        employeeRole
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("Employee Added");

                setEmployeeName("");
                setEmployeeRole("");
                setSelectedTeam("");

                fetchOrgChart();
            }

        } catch (err) {
            console.error(err);
        }
    };

    const savePolicy = async () => {

        const res = await fetch(
            "/gt-api/save_policy.php",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    policyTitle,
                    policyIcon,
                    policyContent
                })
            }
        );

        const data = await res.json();

        if (data.success) {

            alert("Policy Saved");

            setPolicyTitle("");
            setPolicyIcon("📄");
            setPolicyContent("");

            fetchPolicies();
        }

    };

    const fetchPolicies = async () => {

        const res = await fetch(
            "/gt-api/get_policies.php",
            {
                credentials: "include"
            }
        );

        const data = await res.json();

        if (data.success) {

            setPolicies(data.policies);

        }

    };

    useEffect(() => {
        fetchPolicies();
    }, []);

    const saveCareerPathway = async () => {

        if (
            !pathwayTitle ||
            !pathwayContent
        ) {
            alert("Fill all fields");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_career_pathway.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type":
                            "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        pathwayTitle,
                        pathwayIcon,
                        pathwayContent
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert(
                    "Career Pathway Saved"
                );

                setPathwayTitle("");
                setPathwayIcon("📈");
                setPathwayContent("");

                fetchCareerPathways();
            }

        } catch (err) {
            console.error(err);
        }

    };

    const saveFestival = async () => {

        if (!festivalName || !festivalDate) {
            alert("Please fill all fields");
            return;
        }

        try {

            const res = await fetch(
                "/gt-api/save_festival.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        name: festivalName,
                        date: festivalDate,
                        image: festivalImage
                    })
                }
            );

            const data = await res.json();

            if (data.success) {

                alert("Festival Saved");

                setFestivalName("");
                setFestivalDate("");
                setFestivalImage("");

                fetchFestivals();
            }

        } catch (err) {
            console.error(err);
        }

    };

    const completeSetup = async () => {

        const confirmSetup = window.confirm(
            "Are you sure company setup is completed?"
        );

        if (!confirmSetup) return;

        try {

            const res = await fetch(
                "/gt-api/complete_company_setup.php",
                {
                    method: "POST",
                    credentials: "include"
                }
            );

            const data = await res.json();
           console.log("SETUP RESPONSE:", data);
alert(JSON.stringify(data));

            if (data.success) {

                alert("Company setup completed successfully.");

                window.location.href = "/dashboard/Management";

            }

        } catch (err) {

            console.error(err);

        }

    };

    return (
        <div className="company-setup-container animate-fade">

            <div className="module-glass-card">

                <h2 className="cyan-text">
                    ⚙️ COMPANY SETUP
                </h2>




                <div className="cyber-line"></div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "20px"
                    }}
                >
                    <button
                        className="btn-action approve"
                        onClick={completeSetup}
                        style={{
                            padding: "12px 24px",
                            fontWeight: "700"
                        }}
                    >
                        ✅ YES, I HAVE COMPLETED COMPANY SETUP
                    </button>
                </div>

                {/* TABS */}
                <div className="company-tabs">

                    <button
                        className={`btn-action ${activeTab === "campus" ? "approve" : ""}`}
                        onClick={() => setActiveTab("campus")}
                    >
                        🏢 Campus Information
                    </button>

                    <button
                        className={`btn-action ${activeTab === "orgchart" ? "approve" : ""}`}
                        onClick={() => setActiveTab("orgchart")}
                    >
                        🏗 Organization Chart
                    </button>

                    <button
                        className={`btn-action ${activeTab === "policies" ? "approve" : ""}`}
                        onClick={() => setActiveTab("policies")}
                    >
                        📄 Company Policies
                    </button>

                    <button
                        className={`btn-action ${activeTab === "careerpathways"
                            ? "approve"
                            : ""
                            }`}
                        onClick={() =>
                            setActiveTab("careerpathways")
                        }
                    >
                        📈 Career Pathways
                    </button>

                    <button
                        className={`btn-action ${activeTab === "festivals"
                            ? "approve"
                            : ""
                            }`}
                        onClick={() =>
                            setActiveTab("festivals")
                        }
                    >
                        🎊 Festivals
                    </button>

                </div>

                {/* CAMPUS TAB */}
                {/* CAMPUS TAB */}
                {activeTab === "campus" && (

                    <>
                        {/* ================= ADD LOCATION ================= */}
                        <div className="company-section">

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    marginBottom: "25px",
                                    gap: "20px"
                                }}
                            >
                                <div>
                                    <h3 style={{ margin: 0 }}>
                                        🏢 Campus Information
                                    </h3>

                                    <p
                                        style={{
                                            marginTop: "8px",
                                            opacity: 0.8,
                                            fontSize: "13px",
                                            lineHeight: "1.6"
                                        }}
                                    >
                                        Add all office locations that should be visible to employees.
                                        You can add multiple campuses, headquarters, branch offices,
                                        warehouses, client offices, or regional locations.
                                    </p>
                                </div>

                                <button
                                    className="btn-action approve"
                                    onClick={() =>
                                        setFormData({
                                            office_type: "",
                                            region: "",
                                            address: "",
                                            embed_url: "",
                                            map_url: ""
                                        })
                                    }
                                >
                                    ➕ ADD MORE
                                </button>
                            </div>

                            <div className="form-row">

                                <div className="form-group">
                                    <label>Office Type</label>

                                    <input
                                        className="cyber-input"
                                        name="office_type"
                                        value={formData.office_type}
                                        onChange={handleChange}
                                        placeholder="Head Office / Branch Office / Warehouse"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Region</label>

                                    <input
                                        className="cyber-input"
                                        name="region"
                                        value={formData.region}
                                        onChange={handleChange}
                                        placeholder="Pune, India"
                                    />
                                </div>

                            </div>

                            <div className="form-group">
                                <label>Office Address</label>

                                <textarea
                                    className="cyber-input"
                                    rows="3"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="Enter complete office address"
                                />
                            </div>

                            <div className="form-group">
                                <label>Google Maps Embed URL</label>

                                <input
                                    className="cyber-input"
                                    name="embed_url"
                                    value={formData.embed_url}
                                    onChange={handleChange}
                                    placeholder="https://www.google.com/maps/embed?..."
                                />
                            </div>

                            <div className="form-group">
                                <label>Google Navigation URL</label>

                                <input
                                    className="cyber-input"
                                    name="map_url"
                                    value={formData.map_url}
                                    onChange={handleChange}
                                    placeholder="https://maps.google.com/..."
                                />
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "20px"
                                }}
                            >
                                <button
                                    className="btn-action approve"
                                    onClick={handleSave}
                                >
                                    💾 SAVE & ADD LOCATION
                                </button>
                            </div>

                        </div>

                        {/* EXISTING LOCATIONS */}
                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "20px"
                                }}
                            >
                                <h3 style={{ margin: 0 }}>
                                    Existing Locations
                                </h3>

                                <span
                                    style={{
                                        background: "rgba(14,165,233,0.15)",
                                        color: "#38bdf8",
                                        padding: "6px 12px",
                                        borderRadius: "20px",
                                        fontSize: "12px",
                                        fontWeight: "600"
                                    }}
                                >
                                    {locations.length} Locations
                                </span>
                            </div>

                            <div className="admin-table-container">

                                <table
                                    className="cyber-table"
                                    style={{
                                        width: "100%",
                                        tableLayout: "fixed"
                                    }}
                                >

                                    <thead>
                                        <tr>
                                            <th style={{ width: "18%" }}>OFFICE TYPE</th>
                                            <th style={{ width: "18%" }}>REGION</th>
                                            <th style={{ width: "44%" }}>ADDRESS</th>
                                            <th style={{ width: "20%" }}>ACTION</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        {locations.length > 0 ? (

                                            locations.map(loc => (

                                                <tr key={loc.id}>

                                                    <td>{loc.office_type}</td>

                                                    <td>{loc.region}</td>

                                                    <td
                                                        style={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word"
                                                        }}
                                                    >
                                                        {loc.address}
                                                    </td>

                                                    <td style={{ textAlign: "center" }}>

                                                        <button
                                                            onClick={() => handleDelete(loc.id)}
                                                            style={{
                                                                background: "rgba(239,68,68,0.15)",
                                                                color: "#ef4444",
                                                                border: "1px solid rgba(239,68,68,0.35)",
                                                                borderRadius: "10px",
                                                                padding: "10px 18px",
                                                                cursor: "pointer",
                                                                fontSize: "13px",
                                                                fontWeight: "600",
                                                                minWidth: "120px"
                                                            }}
                                                        >
                                                            🗑 Delete
                                                        </button>

                                                    </td>

                                                </tr>

                                            ))

                                        ) : (

                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "center", padding: "40px" }}>
                                                    No Campus Locations Added Yet
                                                </td>
                                            </tr>

                                        )}

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </>

                )}

                {/* ORG CHART TAB */}
                {activeTab === "orgchart" && (

                    <div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "25px"
                            }}
                        >
                            <div>
                                <h3 style={{ margin: 0 }}>
                                    🏗 Organization Chart
                                </h3>

                                <p
                                    style={{
                                        opacity: 0.8,
                                        fontSize: "13px",
                                        marginTop: "8px"
                                    }}
                                >
                                    Configure your company's hierarchy visible to employees.
                                </p>
                            </div>
                        </div>

                        {/* BOARD MEMBERS */}

                        <div className="module-glass-card">

                            <h4 style={{ marginBottom: "20px" }}>
                                👨‍💼 Board Members
                            </h4>

                            <div className="form-row">

                                <div className="form-group">
                                    <label>Name</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="Director Name"
                                        value={boardName}
                                        onChange={(e) => setBoardName(e.target.value)}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Designation</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="Director / CFO / CTO"
                                        value={boardRole}
                                        onChange={(e) => setBoardRole(e.target.value)}
                                    />
                                </div>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "15px"
                                }}
                            >
                                <button
                                    className="btn-action approve"
                                    onClick={saveBoardMember}
                                >
                                    ➕ ADD BOARD MEMBER
                                </button>
                            </div>

                        </div>

                        {/* CEO */}

                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4 style={{ marginBottom: "20px" }}>
                                👑 CEO Information
                            </h4>

                            <div className="form-row">

                                <div className="form-group">
                                    <label>CEO Name</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="CEO Name"
                                        value={ceoName}
                                        onChange={(e) => setCeoName(e.target.value)}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Designation</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="CEO"
                                        value={ceoRole}
                                        onChange={(e) => setCeoRole(e.target.value)}
                                    />
                                </div>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "15px"
                                }}
                            >
                                <button
                                    className="btn-action approve"
                                    onClick={saveCEO}
                                >
                                    💾 SAVE CEO
                                </button>
                            </div>

                        </div>

                        {/* MANAGERS */}

                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4 style={{ marginBottom: "20px" }}>
                                👨‍💼 Managers / Department Heads
                            </h4>

                            <div className="form-row">

                                <div className="form-group">
                                    <label>Manager Name</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="Manager Name"
                                        value={managerName}
                                        onChange={(e) =>
                                            setManagerName(e.target.value)
                                        }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Designation</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="Engineering Manager"
                                        value={managerRole}
                                        onChange={(e) =>
                                            setManagerRole(e.target.value)
                                        }
                                    />
                                </div>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "15px"
                                }}
                            >
                                <button
                                    className="btn-action approve"
                                    onClick={saveManager}
                                >
                                    ➕ ADD MANAGER
                                </button>
                            </div>

                        </div>

                        {/* TEAMS */}

                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4 style={{ marginBottom: "20px" }}>
                                👥 Teams
                            </h4>

                            <div className="form-row">

                                <div className="form-group">
                                    <label>Select Manager</label>

                                    <select
                                        className="cyber-input"
                                        value={selectedManager}
                                        onChange={(e) =>
                                            setSelectedManager(e.target.value)
                                        }
                                    >
                                        <option value="">
                                            Select Manager
                                        </option>

                                        {orgChartData
                                            .filter(x => x.section_type === "MANAGER")
                                            .map(manager => (

                                                <option
                                                    key={manager.id}
                                                    value={manager.id}
                                                >
                                                    {manager.title}
                                                </option>

                                            ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Team Name</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="GTE Software"
                                        value={teamName}
                                        onChange={(e) =>
                                            setTeamName(e.target.value)
                                        }
                                    />
                                </div>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "15px"
                                }}
                            >
                                <button
                                    className="btn-action approve"
                                    onClick={saveTeam}
                                >
                                    ➕ ADD TEAM
                                </button>
                            </div>

                        </div>

                        {/* EMPLOYEES */}

                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4 style={{ marginBottom: "20px" }}>
                                👨‍💻 Team Members
                            </h4>

                            <div className="form-row">

                                <div className="form-group">
                                    <label>Select Team</label>

                                    <select
                                        className="cyber-input"
                                        value={selectedTeam}
                                        onChange={(e) =>
                                            setSelectedTeam(e.target.value)
                                        }
                                    >
                                        <option value="">
                                            Select Team
                                        </option>

                                        {orgChartData
                                            .filter(x => x.section_type === "GROUP")
                                            .map(team => (

                                                <option
                                                    key={team.id}
                                                    value={team.id}
                                                >
                                                    {team.title}
                                                </option>

                                            ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Employee Name</label>

                                    <input
                                        className="cyber-input"
                                        placeholder="Employee Name"
                                        value={employeeName}
                                        onChange={(e) =>
                                            setEmployeeName(e.target.value)
                                        }
                                    />
                                </div>

                            </div>

                            <div className="form-group">

                                <label>Designation</label>

                                <input
                                    className="cyber-input"
                                    placeholder="Software Engineer"
                                    value={employeeRole}
                                    onChange={(e) =>
                                        setEmployeeRole(e.target.value)
                                    }
                                />

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "15px"
                                }}
                            >
                                <button
                                    className="btn-action approve"
                                    onClick={saveEmployee}
                                >
                                    ➕ ADD EMPLOYEE
                                </button>
                            </div>

                        </div>

                        {/* CURRENT STRUCTURE */}

                        {/* <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4>
                                📊 Current Organization Structure
                            </h4>

                            <div>

                                {orgChartData.map(item => (

                                    <div
                                        key={item.id}
                                        style={{
                                            padding: "12px",
                                            borderBottom:
                                                "1px solid rgba(255,255,255,0.08)"
                                        }}
                                    >
                                        <strong>{item.title}</strong>

                                        <br />

                                        <span>{item.subtitle}</span>

                                        <br />

                                        <small>
                                            {item.section_type}
                                        </small>
                                    </div>

                                ))}


                                


                            </div>

                        </div> */}

                        <div
    className="module-glass-card"
    style={{ marginTop: "20px" }}
>
    <h4>👁 Employee View Preview</h4>

    <div className="org-tree">

        <ul>
            <li>

                <div className="node root-node glass board-directors-clean">
                    BOARD OF DIRECTORS
                </div>

                <ul>

                    {orgChartData
                        .filter(x => x.section_type === "BOARD")
                        .map(member => (

                            <li key={member.id}>
                                <div className="node member-node glass">
                                    <h3>{member.title}</h3>
                                    <span className="role-tag">
                                        {member.subtitle}
                                    </span>
                                </div>
                            </li>

                        ))}

                </ul>

                <div className="hierarchy-separator"></div>

                {orgChartData
                    .filter(x => x.section_type === "CEO")
                    .map(ceo => (

                        <ul key={ceo.id}>
                            <li>

                                <div className="node ceo-node glass center-ceo">
                                    <h3>{ceo.title}</h3>
                                    <h4>{ceo.subtitle}</h4>
                                </div>

                                <ul>

                                    {orgChartData
                                        .filter(
                                            x =>
                                                x.section_type === "MANAGER"
                                        )
                                        .map(manager => {

                                            const groups =
                                                orgChartData.filter(
                                                    x =>
                                                        x.section_type ===
                                                        "GROUP" &&
                                                        Number(
                                                            x.parent_id
                                                        ) ===
                                                        Number(
                                                            manager.id
                                                        )
                                                );

                                            return (

                                                <li key={manager.id}>

                                                    <div className="node dept-head glass">
                                                        <div>
                                                            {manager.title}
                                                        </div>

                                                        <small>
                                                            {
                                                                manager.subtitle
                                                            }
                                                        </small>
                                                    </div>

                                                    <ul>

                                                        {groups.map(
                                                            group => {

                                                                const staff =
                                                                    orgChartData.filter(
                                                                        x =>
                                                                            x.section_type ===
                                                                            "STAFF" &&
                                                                            Number(
                                                                                x.parent_id
                                                                            ) ===
                                                                            Number(
                                                                                group.id
                                                                            )
                                                                    );

                                                                return (

                                                                    <li
                                                                        key={
                                                                            group.id
                                                                        }
                                                                    >

                                                                        <div className="node group-title">
                                                                            {
                                                                                group.title
                                                                            }
                                                                        </div>

                                                                        <ul className="staff-column">

                                                                            {staff.map(
                                                                                emp => (
                                                                                    <li
                                                                                        key={
                                                                                            emp.id
                                                                                        }
                                                                                        className="staff-node glass"
                                                                                    >
                                                                                        {
                                                                                            emp.title
                                                                                        }

                                                                                        {emp.subtitle &&
                                                                                            ` (${emp.subtitle})`}
                                                                                    </li>
                                                                                )
                                                                            )}

                                                                        </ul>

                                                                    </li>

                                                                );
                                                            }
                                                        )}

                                                    </ul>

                                                </li>

                                            );
                                        })}

                                </ul>

                            </li>
                        </ul>

                    ))}

            </li>
        </ul>

    </div>
</div>

                    </div>

                )}

                {/* POLICIES TAB */}
                {activeTab === "policies" && (
                    <div>

                        <h3>📄 Company Policies</h3>

                        <div className="module-glass-card">

                            <div className="form-group">

                                <label>Policy Title</label>

                                <input
                                    className="cyber-input"
                                    value={policyTitle}
                                    onChange={(e) => setPolicyTitle(e.target.value)}
                                    placeholder="Probation Policy"
                                />

                            </div>

                            <div className="form-group">

                                <label>Icon</label>

                                <input
                                    className="cyber-input"
                                    value={policyIcon}
                                    onChange={(e) => setPolicyIcon(e.target.value)}
                                    placeholder="📄"
                                />

                            </div>

                            <div className="form-group">

                                <label>Policy Content</label>

                                <textarea
                                    className="cyber-input"
                                    rows="15"
                                    value={policyContent}
                                    onChange={(e) => setPolicyContent(e.target.value)}
                                />

                            </div>

                            <button
                                className="btn-action approve"
                                onClick={savePolicy}
                            >
                                💾 SAVE POLICY
                            </button>

                        </div>

                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4
                                style={{
                                    marginBottom: "20px",
                                    color: "#fff"
                                }}
                            >
                                📚 Existing Policies
                            </h4>

                            {policies.length > 0 ? (

                                policies.map(policy => {

                                    console.log("POLICY DATA =>", policy);

                                    return (

                                        <div
                                            key={policy.id}
                                            style={{
                                                padding: "20px",
                                                marginBottom: "18px",
                                                borderRadius: "14px",
                                                background: "rgba(255,255,255,0.04)",
                                                border: "1px solid rgba(255,255,255,0.08)"
                                            }}
                                        >





                                            {/* HEADER */}

                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: "15px"
                                                }}
                                            >

                                                <div
                                                    style={{
                                                        fontSize: "20px",
                                                        fontWeight: "700",
                                                        color: "#38bdf8"
                                                    }}
                                                >
                                                    {policy.policy_icon || "📄"} {policy.policy_title}
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        opacity: 0.6
                                                    }}
                                                >
                                                    {policy.created_at}
                                                </div>

                                            </div>

                                            {/* CONTENT */}

                                            <div
                                                style={{
                                                    whiteSpace: "pre-wrap",
                                                    lineHeight: "1.9",
                                                    fontSize: "14px",
                                                    opacity: 0.9,
                                                    maxHeight: "250px",
                                                    overflowY: "auto",
                                                    paddingRight: "10px"
                                                }}
                                            >
                                                {policy.policy_content}
                                            </div>

                                        </div>

                                    );

                                })

                            ) : (

                                <div
                                    style={{
                                        textAlign: "center",
                                        padding: "40px",
                                        opacity: 0.7
                                    }}
                                >
                                    📭 No Policies Added Yet
                                </div>

                            )}
                        </div>




                    </div>

                )}

                {activeTab === "careerpathways" && (

                    <div>

                        <h3>📈 Career Pathways</h3>

                        <div className="module-glass-card">

                            <div className="form-group">
                                <label>Pathway Title</label>

                                <input
                                    className="cyber-input"
                                    value={pathwayTitle}
                                    onChange={(e) =>
                                        setPathwayTitle(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Power BI"
                                />
                            </div>

                            <div className="form-group">
                                <label>Icon</label>

                                <input
                                    className="cyber-input"
                                    value={pathwayIcon}
                                    onChange={(e) =>
                                        setPathwayIcon(
                                            e.target.value
                                        )
                                    }
                                    placeholder="📈"
                                />
                            </div>

                            <div className="form-group">
                                <label>Career Pathway Content</label>

                                <textarea
                                    rows="20"
                                    className="cyber-input"
                                    value={pathwayContent}
                                    onChange={(e) =>
                                        setPathwayContent(
                                            e.target.value
                                        )
                                    }
                                />
                            </div>

                            <button
                                className="btn-action approve"
                                onClick={saveCareerPathway}
                            >
                                💾 SAVE PATHWAY
                            </button>

                        </div>

                    </div>

                )}

                {activeTab === "festivals" && (

                    <div>

                        <h3>🎊 Company Festivals</h3>

                        <div className="module-glass-card">

                            <div className="form-group">
                                <label>Festival Name</label>

                                <input
                                    className="cyber-input"
                                    value={festivalName}
                                    onChange={(e) =>
                                        setFestivalName(e.target.value)
                                    }
                                    placeholder="Diwali"
                                />
                            </div>

                            <div className="form-group">
                                <label>Festival Date</label>

                                <input
                                    type="date"
                                    className="cyber-input"
                                    value={festivalDate}
                                    onChange={(e) =>
                                        setFestivalDate(e.target.value)
                                    }
                                />
                            </div>

                            <div className="form-group">
                                <label>Festival Image URL (Optional)</label>

                                <input
                                    className="cyber-input"
                                    value={festivalImage}
                                    onChange={(e) =>
                                        setFestivalImage(e.target.value)
                                    }
                                    placeholder="festival image path"
                                />
                            </div>

                            <button
                                className="btn-action approve"
                                onClick={saveFestival}
                            >
                                💾 SAVE FESTIVAL
                            </button>

                        </div>

                        <div
                            className="module-glass-card"
                            style={{ marginTop: "20px" }}
                        >

                            <h4>🎉 Existing Festivals</h4>

                            {festivals.map(festival => (

                                <div
                                    key={festival.id}
                                    style={{
                                        padding: "15px",
                                        borderBottom:
                                            "1px solid rgba(255,255,255,0.08)"
                                    }}
                                >

                                    <strong>{festival.name}</strong>

                                    <br />

                                    <span>{festival.date}</span>

                                </div>

                            ))}

                        </div>

                    </div>

                )}



            </div>




        </div>
    );
};

export default CompanySetup;